import { render, staticRenderFns } from "./App.vue?vue&type=template&id=101210f8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=101210f8&prod&lang=css"
import style1 from "./app.less?vue&type=style&index=1&prod&lang=less&external"
import style2 from "./app_m.less?vue&type=style&index=2&prod&lang=less&external"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports